<template>
  <card :title="title" class="folder-card" :body-padding="'10px'">
    <span slot="extra">共{{ images.length }}张</span>
    <div class="weui-uploader-folder__bd">
      <ul
        class="weui-uploader-folder__files"
        id="uploaderFiles"
        v-viewer="options"
      >
        <li
          v-for="(image, i) in list"
          :key="i"
          :class="'weui-uploader-folder__file '"
        >
          <Thumb class="picImg" :src="image.thumbnail" :originUrl="image.src" />
          <span
            v-if="canDelete"
            @click.stop="handleClose(i)"
            class="vux-close weui-uploader-folder__file-close"
          ></span>
        </li>
        <li>
          <div
            class="weui-uploader-folder__input-box"
            v-if="!disabled && list.length < max"
          >
            <input
              @change="upload"
              style="display: none"
              id="uploaderInput"
              capture="camera"
              class="weui-uploader__input"
              type="file"
              accept="image/*"
            />
            <div class="weui-uploader-folder__container" @click="uploadClick"
            >
              <div>
                <div class="weui-uploader-folder-icon">
                  <Icon type="iconxiangji" />
                </div>
                <p class="weui-uploader-folder-text">点击上传</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </card>
</template>

<script>
import { compress } from "./compressor";
import { TransferDom } from "vux";
import { uploadFile, adminUploadFile } from "@/api/file";
import { Card } from "@/components/Card";
import Thumb from "@/components/Thumb/Thumb";

export default {
  name: "Uploader",
  directives: { TransferDom },
  components: { Card, Thumb },
  props: {
    id: {
      type: [String, Number]
    },
    title: {
      type: String
    },
    value: {
      type: Array
    },
    params: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fileName: {
      type: String,
      default: "file"
    },
    max: {
      type: Number,
      default: 10
    },
    canDelete: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: "user"
    }
  },
  data() {
    return {
      images: [],
      hasAuth:false
    };
  },
  computed: {
    list() {
      return this.images.map(image => {
        let thumbnail = image;
        if (image.indexOf("?") !== -1) {
          thumbnail =
            image +
            "&x-oss-process=image/resize,m_fill,h_" +
            this.getHeight() +
            ",w_" +
            this.getWidth();
        } else {
          thumbnail =
            image +
            "?&x-oss-process=image/resize,m_fill,h_" +
            this.getHeight() +
            ",w_" +
            this.getWidth();
        }
        return { thumbnail, src: image };
      });
    }
  },
  watch: {
    value(val) {
      this.images = val;
    }
  },
  created() {
    this.options = {
      url: image => {
        return image.getAttribute("origin-url");
      }
    };
  },
  methods: {
    getWidth() {
      return 90;
    },
    getHeight() {
      return 90;
    },
    handleClose(i) {
      let result = confirm("确认删除?");
      if (result) {
        const images = this.images.slice(0, i).concat(this.images.slice(i + 1));
        this.$emit("input", images);
        this.$emit("change", images);
      }
    },
    upload(e) {
      compress(e.target.files[0]).then(result => {
        const { file } = result;
        const form = new FormData();
        form.append(this.fileName, file);

        Object.keys(this.params).forEach(key => {
          form.append(key, this.params[key]);
        });

        this.$vux.loading.show({
          text: "上传中"
        });

        let upload = this.type === "user" ? uploadFile : adminUploadFile;
        return upload(form)
          .then(res => {
            const images = this.images.concat(res.link);
            this.$emit("change", images);
            this.$emit("input", images);
            this.$vux.loading.hide();
          })
          .catch(err=>{
            this.$vux.loading.hide();
            this.$showError(err)
          })
      });
    },
    uploadClick(){
      if(this.hasAuth){
        document.getElementById('uploaderInput').click();
      }
      else {
        // let result = confirm("授权提示：我们需要访问您的相机、相册或者本地文件");
        let result = confirm("授权提示：我们需要访问您的相机");
        if (result) {
          this.hasAuth=true
          document.getElementById('uploaderInput').click();
        }
      }
    }
  }
};
</script>

<style lang="less">
@import "~vux/src/styles/weui/widget/weui-uploader/index.less";
.weui-uploader-folder {
  &__bd {
    display: flex;
  }
  &__files {
    list-style: none;
    display: flex;
    flex-flow: wrap;
  }
  &__input-box {
    position: relative;
    margin-right: 9px;
    width: 90px;
    height: 90px;
  }
  &-icon {
    text-align: center;
    .icon {
      font-size: 25px;
    }
  }
  &-text {
    font-size: 12px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(145, 145, 145, 1);
  }
  &__container {
    height: 90px;
    width: 90px;
    border: 1px dashed rgba(226, 226, 226, 1);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__file {
    margin-right: 9px;
    margin-bottom: 9px;
    width: 90px;
    height: 90px;
    background: no-repeat center center;
    background-size: cover;
    position: relative;
    &-close {
      position: absolute;
      right: 0;
      top: 0;
      color: red;
    }
  }
}
</style>
